import Title from "../../../sharedComponents/title/Title";
import { Icon } from "@iconify/react";

const Contact = () => {
  return (
    <div className="w-full" id="contact-us">
      <Title heading="Contact Us" />

      {/* HERO SECTION */}
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-12">
        {/* Background decorative elements */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute -top-20 -right-20 w-72 h-72 bg-orange-100 rounded-full opacity-40 blur-3xl"></div>
          <div className="absolute -bottom-20 -left-20 w-72 h-72 bg-red-100 rounded-full opacity-40 blur-3xl"></div>
        </div>

        <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* LEFT: GET IN TOUCH */}
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold mb-4 bg-gradient-to-r from-orange-500 to-red-600 bg-clip-text text-transparent">
              Get In Touch
            </h2>
            <p className="text-gray-600 max-w-md leading-relaxed text-lg">
              Have a shipment to move or need a delivery quote? Our team is
              ready to assist you with fast, reliable, and secure cargo
              solutions. Whether it's local delivery or international freight,
              we're here to make your logistics simple and stress-free.
            </p>

            {/* CTA Button */}
            <a
              href="tel:+447775318440"
              className="inline-flex items-center gap-2 mt-6 px-6 py-3 bg-gradient-to-r from-orange-500 to-red-600 text-white font-semibold rounded-full shadow-lg shadow-orange-500/30 hover:shadow-xl hover:shadow-orange-500/40 hover:scale-105 transition-all duration-300"
            >
              <Icon icon="lucide:phone-call" width="20" />
              Call Us Now
            </a>
          </div>

          {/* RIGHT: CONTACT CARDS */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {/* Office Card */}
            <div className="group bg-white rounded-2xl p-6 shadow-md hover:shadow-xl border border-gray-100 hover:border-orange-200 transition-all duration-300 hover:-translate-y-1">
              <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-orange-400 to-red-500 rounded-xl mb-4 group-hover:scale-110 transition-transform duration-300">
                <Icon icon="gis:poi-map-o" width="24" className="text-white" />
              </div>
              <h4 className="font-bold text-gray-800 mb-2">Our Main Office</h4>
              <p className="text-sm text-gray-500 leading-relaxed">
                Rear Ground Floor,
                <br />
                124 Whitechapel Road,
                <br />
                London E1 1JE
              </p>
              {/* Rear Ground Floor, 124 Whitechapel Road London E1 1JE */}
            </div>

            {/* Phone Card */}
            <div className="group bg-white rounded-2xl p-6 shadow-md hover:shadow-xl border border-gray-100 hover:border-orange-200 transition-all duration-300 hover:-translate-y-1">
              <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-orange-400 to-red-500 rounded-xl mb-4 group-hover:scale-110 transition-transform duration-300">
                <Icon
                  icon="lucide:phone-call"
                  width="24"
                  className="text-white"
                />
              </div>
              <h4 className="font-bold text-gray-800 mb-2">Phone Number</h4>
              <p className="text-sm text-gray-500 leading-relaxed">
                <a
                  href="tel:+447460337354"
                  className="hover:text-orange-500 transition-colors"
                >
                  +44 7460 337354
                </a>
                <br />
                <a
                  href="tel:03338002439"
                  className="hover:text-orange-500 transition-colors"
                >
                  0333 800 2439
                </a>
                <br />
                <a
                  href="tel:+447775318440"
                  className="hover:text-orange-500 transition-colors"
                >
                  +44 7775 318440
                </a>
              </p>
              <div className="mt-2 inline-flex items-center gap-1.5 bg-green-50 px-3 py-1 rounded-full">
                <Icon icon="logos:whatsapp-icon" width="16" />
                <a
                  href="https://wa.me/8801723925785"
                  className="text-sm text-green-700 font-medium hover:text-green-800 transition-colors"
                >
                  +880 1723 925785
                </a>
              </div>
            </div>

            {/* Email Card */}
            <div className="group bg-white rounded-2xl p-6 shadow-md hover:shadow-xl border border-gray-100 hover:border-orange-200 transition-all duration-300 hover:-translate-y-1 sm:col-span-2">
              <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-orange-400 to-red-500 rounded-xl mb-4 group-hover:scale-110 transition-transform duration-300">
                <Icon
                  icon="clarity:email-solid"
                  width="24"
                  className="text-white"
                />
              </div>
              <h4 className="font-bold text-gray-800 mb-2">E-Mail</h4>
              <a
                href="mailto:info@sundarbancargo.com"
                className="text-sm text-gray-500 hover:text-orange-500 transition-colors"
              >
                info@sundarbancargo.com
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* MAP */}
      <div className="mt-12 w-full h-[400px] lg:h-[500px] rounded-t-3xl overflow-hidden shadow-2xl">
        <iframe
          title="Map"
          loading="lazy"
          className="w-full h-full border-0"
          allowFullScreen
          src="https://www.google.com/maps/embed/v1/place?q=124+Whitechapel+road+E11JE+LONDON+UK&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"
        ></iframe>
      </div>
    </div>
  );
};

export default Contact;
